<template>
  <div class="list-group pt-3 px-5">
    <div
      v-for="actionCategories in sortedActions"
      :key="(categoryName = Object.keys(actionCategories)[0])"
      class="list-group-item bg-transparent d-flex align-items-center justify-content-between border-0 p-0"
    >
      <p class="fs-6">
        {{ $tr(categories[categoryName]?.messages, 'title') }}
      </p>
      <div v-if="numberOfUsersThatHaveResponded >= 1">
        <p class="fs-8">
          {{
            $t(
              'widgetGroupActions.people',
              actionCategories[categoryName].numberOfActions
            )
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProposalActions',
  props: {
    action: {
      type: Object,
      default: () => {}
    },
    categories: {
      type: Object,
      default: () => {}
    },
    numberOfUsersThatHaveResponded: Number
  },
  computed: {
    sortedActions() {
      const sorted = this.action.categories.toSorted((a, b) => {
        const categoryNameA = Object.keys(a)[0]
        const categoryNameB = Object.keys(b)[0]

        return (
          b[categoryNameB].numberOfActions - a[categoryNameA].numberOfActions
        )
      })
      return sorted
    }
  }
}
</script>
